<template>
  <div>
    <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }">
      <div id="myCals">
        <div class="title_">
          <div class="cutleft_">保费试算</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="changeStyle_">
          <a-col :span="18">
            <div class="form_item">
              <a-form-item :label-col="{ span: 16 }" class="blod" label="工程造价(单位:元)">
                <a-input style="width: 300px" :disabled="disabledAll" v-model="countData.projectamount" @change="value => changeData(value.target.value, 'projectamount')" placeholder="工程造价" />
              </a-form-item>
            </div>
            <div class="form_item">
              <label style="font-weight: 600">保障方案</label>
              <div class="right_">
                <a-select :disabled="disabledAll" v-model="countData.plan" :label-col="{ span: 15 }" placeholder="保障方案" style="width: 300px" class="select_" @change="value => changeData(value, 'plan')">
                  <a-select-option v-for="(item, index) in planList" :key="item.value + 'desc' + index" :value="item.value">{{ item.name }}</a-select-option>
                </a-select>
              </div>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="意外身故/残疾">
                <a-input disabled style="width: 300px" :value="planList[deshIdx].money1" placeholder="意外身故/残疾" />
              </a-form-item>
            </div>
            <div class="form_item ml20">
              <a-form-item :label-col="{ span: 16 }" label="意外医疗费用">
                <a-input disabled style="width: 300px" :value="planList[deshIdx].money2" placeholder="意外医疗费用" />
              </a-form-item>
            </div>
            <div class="btn_list">
              <a-button class="calBtn_" :disabled="disabledAll" type="primary" @click="countPremiumSum()">刷新试算</a-button>
              <a-button style="margin-bottom: 50px" class="calBtn_" type="primary" v-if="!agreementRead" @click="goplicy" :disabled="disabledAll">完成报价，立即投保</a-button>
            </div>
          </a-col>
          <a-col :offset="2" :span="4" class="calRight_ policy_none">
            <div class="calTxt_">保费合计</div>
            <div class="calmoney_">¥ {{ totalPremium }}</div>
          </a-col>
        </a-row>
      </div>
    </a-form>
  </div>
</template>

<script>
let DATA = require('../data').default;
import { riskinfoMixin } from '@/mixins/riskinfoMixin.js';
export default {
  mixins: [riskinfoMixin],
  data() {
    return {
      data: {},
      plan: 'P060306-T1',
      totalPremium: 0,
      planList: DATA.plansValues, //计划列表
      countData: {
        plan: 'P060306-T1',
        projectamount: '',
      },
    };
  },
  computed: {
    planIdx() {
      let idx = 0;
      this.planList.forEach((item, i) => {
        if (item.value == this.countData.plan) {
          idx = i;
        }
      });
      return idx;
    },

    deshIdx() {
      let idx = 0;
      this.planList.forEach((item, i) => {
        if (item.value == this.countData.plan) {
          idx = i;
        }
      });
      return idx;
    },
  },
  props: ['disabledAll'],
  created() {
    const { u, p, planCode } = this.$route.query;
    this.creator = u;
    this.productCode = p;
    this.plan = planCode || 'P060306-T1';
    this.changeData(this.plan, 'plan')
  },
  mounted() {
    this.$bus.$on('busRiskInfos', data => {
      let obj = this.$lodash.cloneDeep(this.countData);
      this.countData = { ...obj };
      this.countData.plan = data.salPolicy.planCode;
      this.countData.projectamount = data.salPolicyHolder.projectamount;
    });
  },
  methods: {
    // 去投保
    goplicy() {
      this.$store.commit('setAgreement', true);
    },
    // 改变试算的数据
    changeData(value, param) {
      if(param=='projectamount'&&value>10000000){
         this.countData[param] = '';
         this.$message.error('工程造价不能超过1000万！');
         return
      }
      this.countData[param] = value;
      this.data = {
        salPolicy: {
          productCode: this.$route.query.p, //产品code
          optionalFlag: 6, //保费期限
          planCode: this.countData.plan,
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          projectamount: this.countData.projectamount, //地区系数
        }
      };
      this.$bus.$emit('onRiskInfos', this.data);
    },

    //保费试算
    countPremiumSum() {
      if(! this.countData.projectamount) {
        this.$message.warn('工程造价不能为空');
        return
      }
      this.data.salPolicyHolder.addfifty = '1';
      this.$api.calPremiumEmployer(this.data).then(res => {
        console.log(res)
        if (res.data.success) {
          let data = res.data.content;
          this.totalPremium = data.totalPremium;
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
  },
};
</script>
<style>
#myCals .ant-form-item {
  margin-bottom: 5px !important;
}
.blod .ant-col label {
  font-weight: 600;
}
#myCals .ml20 {
  padding-left: 10px;
}
</style>
<style lang="scss" scoped>
#myCals {
  .policy {
    display: none;
  }
  .redText {
    position: absolute;
    right: -80px;
    color: red;
    top: 16px;
  }
  .calTxt_ {
    font-size: 18px !important;
    font-weight: bold !important;
    color: #666666;
  }
  .pre-box {
    margin-top: 15px;
  }
  .form_items {
    display: flex;
    width: 100%;
    color: #333;
    margin-bottom: 10px;
  }
  .btn_list {
    margin-top: 20px;
    display: flex;

    .calBtn_ {
      margin-right: 30px;
    }
  }
  .flex_ {
    display: flex;
    flex-wrap: wrap;
  }
  .form_item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: #333;
    margin-bottom: 10px !important;

    &.width_50 {
      width: 50%;
    }

    &.width_40 {
      width: 40%;
    }

    &.width_60 {
      width: 60%;
    }

    > label {
      white-space: nowrap;
      margin-right: 10px;
      margin-top: 15px;
    }

    .right_ {
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      position: relative;

      .select_ {
        margin-top: 10px;
      }

      .check_item {
        display: flex;
        align-items: center;
        margin-right: 10px;
        margin-top: 10px;

        &.on {
          label {
            border-color: #fe8f2d;
          }
        }

        label {
          // border: 1px solid #d9d9d9;
          padding: 3px 10px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &.s_input input {
          width: 50px;
        }

        input {
          width: 150px;
          margin-right: 5px;
        }
      }
    }
  }
  .p-header {
    width: 100%;
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 0;
  }

  .form_item {
    margin-bottom: 0;
    .ant-form-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .aftertext {
    position: relative;
  }
  .aftertext::after {
    content: '500000元起保';
    position: absolute;
    color: #999999;
    top: 10px;
    right: 30px;
    z-index: 2;
  }
  .tiaokuan_list {
    line-height: 24px;
  }
}
</style>